<template>
  <section>
    <div class="form-content">
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="送修单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送修人">
            <user-info :userData='userData'></user-info>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="维修车辆">
        <el-select @change="forceUpdate" size="small" class="project-list-select" v-model="form.carId" filterable placeholder="请选择(可搜索车牌号)">
          <el-option v-for="item in carList" :key="item.id" :label="item.xh+' - '+item.plateNo+' - '+item.type"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="维修单位">
            <el-input size="small" v-model="form.wxdw"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计费用(元)">
            <el-input size="small" type="number" placeholder="预计维修费用(元)" v-model="form.price"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="送修日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.startTime" type="date"
              placeholder="送修日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="完成日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.endTime" type="date"
              placeholder="完成日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="报修内容">
        <el-input type="textarea" placeholder="申请修理的内容" :autosize="{ minRows: 5, maxRows: 8}" size="small"
          v-model="form.reason"></el-input>
      </el-form-item>



    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', 'useApplyType', 'carType'],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    components: {
      UserInfo,
    },
    data() {
      return {
        form: {},
        carList: [],
        depId: "",
      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      this.getCarLists()
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取所有车辆
      getCarLists() {
        ajax.get('/car/list', {
          depId: this.depId
        }, (res) => {
          this.loading = false
          this.carList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      },
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/car/repair.vue